import { combineReducers } from 'redux';

import application from './features/application';
import { STATE as APPLICATION_STATE } from './features/application/types/state';

import auth from './features/auth';
import { STATE as AUTH_STATE } from './features/auth/types/state';

import station from './features/station';
import { STATE as STATION_STATE } from './features/station/types/state';

import directories from './features/directories';
import { STATE as DIRECTORIES_STATE } from './features/directories/types/state';

import stations from './features/stations';
import { STATE as STATIONS_STATE } from './features/stations/types/state';

import cards from './features/cards';
import { STATE as CARDS } from './features/cards/types/state';

import user from './features/user';
import { STATE as USER } from './features/user/types/state';

import events from './features/events';
import { STATE as EVENTS } from './features/events/types/state';

import { REPORTS_STATE, reportsReducer } from 'entities/reports';

import favoriteCatalogs from './features/favoriteCatalogs';
import { STATE as FAVORITE_CATALOGS } from './features/favoriteCatalogs/types/state';

import fuelCards from './features/fuelCards';
import { STATE as FUEL_CARDS } from './features/fuelCards/types/state';

import savedFilters from './features/savedFilters';
import { STATE as SAVED_FILTERS } from './features/savedFilters/types/state';

const reducer = combineReducers({
  [APPLICATION_STATE]: application,
  [AUTH_STATE]: auth,
  [STATION_STATE]: station,
  [DIRECTORIES_STATE]: directories,
  [STATIONS_STATE]: stations,
  [CARDS]: cards,
  [USER]: user,
  [REPORTS_STATE]: reportsReducer,
  [EVENTS]: events,
  [FAVORITE_CATALOGS]: favoriteCatalogs,
  [FUEL_CARDS]: fuelCards,
  [SAVED_FILTERS]: savedFilters,
});

export default reducer;
